import InstantSearchSelect from "../../../ui/components/InstantSearch/InstantSearchSelect";

import Form from "../../../forms/components/Form/Form";

export default function ArticleMetaDataTagsSelect() {
	const { watch } = Form.useFormContext();

	const language = watch("language");

	return (
		<Form.Field name="tags">
			<InstantSearchSelect
				multiple
				allowEmpty
				clearable
				allowAdditions
				indexName="articles"
				filters={`language:${language}`}
				refinement={{
					attribute: "tags",
					limit: 10,
				}}
				getOption={({ value, count }, index) => {
					return {
						key: `tags-${index}`,
						value: value,
						text: value,
						label: { circular: true, content: count },
					};
				}}
			/>
		</Form.Field>
	);
}
